    import React from "react";
    import {
    Box,
    Typography,
    Container,
    Card,
    CardContent,
    Button,
    Grid,
    useTheme
    } from "@mui/material";
    import { Description, Download, PictureAsPdf } from "@mui/icons-material";
    import reportFile from "../../../assets/Annual_Report_2024.pdf";

    function Reports() {
    const theme = useTheme();

    return (
    <Box component="section" sx={{ 
        py: 8,
        backgroundColor: theme.palette.background.paper
    }}>
        <Container maxWidth="lg">
        <Typography 
            variant="h5" 
            align="center" 
            gutterBottom
            sx={{
            fontWeight: 700,
            color: theme.palette.primary.main,
            mb: 4,
            position: 'relative',
            '&:after': {
                content: '""',
                position: "absolute",
                width: "80px",
                height: "4px",
                bottom: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: theme.palette.primary.main,
                borderRadius: "2px",
            },
            }}
        >
            Our Annual Reports
        </Typography>

        <Grid container justifyContent="center" spacing={4}>
            <Grid item xs={12} md={8}>
            <Card sx={{ 
                borderRadius: 2,
                boxShadow: 3,
                transition: 'transform 0.3s',
                '&:hover': {
                transform: 'translateY(-5px)'
                }
            }}>
                <CardContent sx={{ p: 4 }}>
                <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    mb: 3
                }}>
                    <PictureAsPdf 
                    color="error" 
                    sx={{ 
                        fontSize: 48,
                        mr: 2 
                    }} 
                    />
                    <Box>
                    <Typography variant="h6" component="div">
                        Annual Report 2024
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        PDF Document • Updated {new Date().toLocaleDateString()}
                    </Typography>
                    </Box>
                </Box>

                <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                    Our comprehensive annual report containing financial statements, 
                    performance metrics, and strategic outlook for the coming year.
                </Typography>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2
                }}>
                    <Button
                    variant="outlined"
                    startIcon={<Description />}
                    component="a"
                    href={reportFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        px: 4,
                        py: 1.5,
                        borderWidth: 2,
                        '&:hover': {
                        borderWidth: 2
                        }
                    }}
                    >
                    View Report
                    </Button>

                    <Button
                    variant="contained"
                    startIcon={<Download />}
                    component="a"
                    href={reportFile}
                    download="Company_Annual_Report.pdf"
                    sx={{
                        px: 4,
                        py: 1.5,
                        backgroundColor: theme.palette.primary.dark,
                        '&:hover': {
                        backgroundColor: theme.palette.primary.main
                        }
                    }}
                    >
                    Download
                    </Button>
                </Box>
                </CardContent>
            </Card>
            </Grid>
        </Grid>

        <Box sx={{ 
            mt: 6,
            textAlign: 'center',
            color: theme.palette.text.secondary
        }}>
            <Typography variant="body2">
            For older reports or additional documents, please contact our support team.
            </Typography>
        </Box>
        </Container>
    </Box>
    );
    }

export default Reports;